import { useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Absences from "@/pages/shared/Absences";
import { EventsTab } from "@/pages/shared/VieScolaire";
import Appel from "@/pages/shared/assiduite/Appel";
import AssiduiteStats from "@/pages/shared/assiduite/AssiduiteStats";
import { useClasses } from "@/lib/activeClass";

const TABS = [["appel", "Appel et présences"], ["absences", "Absences et retards"], ["stats", "Statistiques et rapports"]];

export default function Assiduite() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const tab = TABS.some(([k]) => k === params.get("tab")) ? params.get("tab") : "appel";
  const { classes, classId, setClassId } = useClasses();
  const canEdit = user.role === "maitre";

  return (
    <div className="space-y-5" data-testid="assiduite-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold" style={{ fontFamily: "Outfit" }}>Absences des élèves</h1>
          <p className="text-sm text-[#5C736A]">Vie scolaire — appel, absences, retards et rapports d&apos;assiduité, classe par classe.</p>
        </div>
        <div className="flex items-center gap-2">
          <Label className="text-xs text-[#5C736A]">Classe / groupe</Label>
          <Select value={classId} onValueChange={setClassId}>
            <SelectTrigger className="w-48" data-testid="assiduite-class-select"><SelectValue placeholder="—" /></SelectTrigger>
            <SelectContent>{classes.map((c) => <SelectItem key={c.id} value={c.id}>{c.nom}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v }, { replace: true })}>
        <TabsList className="w-full overflow-x-auto flex justify-start">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`assiduite-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="appel" className="mt-5"><Appel classId={classId} canEdit={canEdit} /></TabsContent>
        <TabsContent value="absences" className="mt-5 space-y-8">
          {classId && <Absences classId={classId} />}
          {classId && <EventsTab tabKey="retards" types={["retard"]} classId={classId} canEdit={canEdit} title="Retards" />}
        </TabsContent>
        <TabsContent value="stats" className="mt-5"><AssiduiteStats classId={classId} /></TabsContent>
      </Tabs>
    </div>
  );
}
